import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-choose-us-two',
  templateUrl: './why-choose-us-two.component.html',
  styleUrls: ['./why-choose-us-two.component.scss']
})
export class WhyChooseUsTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
